import { render, staticRenderFns } from "./ExtraActionProject.vue?vue&type=template&id=043145d3&"
import script from "./ExtraActionProject.vue?vue&type=script&lang=js&"
export * from "./ExtraActionProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports